import { AnyAction } from 'redux';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { MessageResponse } from '../../../_helpers/iResponse';
import { RootState } from '../../../store';
import * as Constants from '../constants';
import * as Services from '../services';

export function* getTeamInit(_action: AnyAction) {
  const teamId = (state: RootState) => state.authReducer.user.teamMember.team_id;

  try {
    const team_id: string = yield select(teamId);
    const response: any = yield call(Services.getTeam, team_id);

    if (response.data.message === MessageResponse.OK) {
      yield put({
        type: Constants.GET_TEAM_SUCCESS,
        payload: { ...response.data.data }
      });
    }
  } catch (e) {
    yield put({ type: Constants.GET_TEAM_FAILED, errors: e });
  }
}
function* getTeam(action: AnyAction) {
  const teamId = (state: RootState) => state.authReducer.user.teamMember.team_id;

  try {
    const team_id: string = yield select(teamId);
    const response: any = yield call(Services.getTeam, team_id);

    if (response.data.message === MessageResponse.OK) {
      yield put({
        type: Constants.GET_TEAM_SUCCESS,
        payload: { ...response.data.data }
      });
      return action.resolve(true);
    }
  } catch (e) {
    yield put({ type: Constants.GET_TEAM_FAILED, errors: e });
    return action.reject(e);
  }
}
function* createTeamMember(action: AnyAction) {
  try {
    const response: any = yield call(Services.createTeamMember, action.teamMember);

    if (response.data.message === MessageResponse.CREATED) {
      yield put({
        type: Constants.CREATE_TEAM_MEMBER_SUCCESS,
        payload: {
          ...response.data.data,
          teamMember: action.teamMember
        }
      });
      return action.resolve(response.data.data.id);
    }
  } catch (e) {
    yield put({ type: Constants.CREATE_TEAM_MEMBER_FAILED, e });
    return action.reject(e);
  }
}

function* updateTeamMember(action: AnyAction) {
  try {
    const response: any = yield call(Services.updateTeamMember, action.teamMember);

    if (response.data.message === MessageResponse.UPDATED) {
      yield put({
        type: Constants.UPDATE_TEAM_MEMBER_SUCCESS,
        payload: {
          ...response.data.data,
          teamMember: action.teamMember
        }
      });
      return action.resolve(response.data.data.id);
    }
  } catch (e) {
    yield put({ type: Constants.UPDATE_TEAM_MEMBER_FAILED, e });
    return action.reject(e);
  }
}

function* deleteTeamMember(action: AnyAction) {
  try {
    const response: any = yield call(Services.deleteTeamMember, action.teamMember);

    if (response.data.message === MessageResponse.DELETED) {
      yield put({
        type: Constants.DELETE_TEAM_MEMBER_SUCCESS,
        payload: {
          ...response.data.data
        }
      });
      return action.resolve(true);
    }
  } catch (e) {
    yield put({ type: Constants.DELETE_TEAM_MEMBER_FAILED, e });
    return action.reject(e);
  }
}

export const teamSagas = [
  takeLatest(Constants.GET_TEAM, getTeam),
  takeLatest(Constants.CREATE_TEAM_MEMBER, createTeamMember),
  takeLatest(Constants.UPDATE_TEAM_MEMBER, updateTeamMember),
  takeLatest(Constants.DELETE_TEAM_MEMBER, deleteTeamMember)
];
